import {getMarketingProductAttributes} from './getMarketingProductAttributes'

export const triggerAddToCartEvent = ({product, qyt, isInStorePickUp, usid, category}) => {
    const {c_AvailableForShipToStore, c_availableForInStorePickup, master} = product
    const orderType = isInStorePickUp ? 'BOPIS' : 'Ship'
    const bopisEligible = c_AvailableForShipToStore || c_availableForInStorePickup ? 'Yes' : 'No'
    const id = master?.masterId || product.id
    const categoryPath = category?.parentCategoryTree?.map((cat) => cat.name).join('/') || ''
    window.dataLayer.push({
        event: 'addToCart',
        session_id: usid,
        ecommerce: {
            add: {
                actionField: {
                    shipType: orderType
                },
                products: [
                    {
                        id: id,
                        name: product?.name,
                        price: product.price,
                        quantity: qyt,
                        ATS: product?.inventory?.ats || 0,
                        bopis_eligible: bopisEligible,
                        bopis_type: orderType,
                        category: categoryPath,
                        onlineFlag: true,
                        variant: product.id,
                        dimension7: orderType,
                        ...getMarketingProductAttributes(product)
                    }
                ]
            }
        }
    })
}
